import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IImageListItem, IImageListViewProps } from '@msdyn365-commerce-modules/image-list';
import { ISvgItemsData } from '../definition-extensions/image-list.ext.props.autogenerated';

export const imageListView = (props: IImageListViewProps): JSX.Element => {
    const { imageList, imageListContainer, imageListHeading, imageListItem, imageListItems, imageListItemAnchorTag } = props;

    const svgItems: Array<ISvgItemsData> = (props.config as { svgItems?: ISvgItemsData[] })?.svgItems || [];

    return (
        <Module {...imageList}>
            {imageListHeading}
            <Node {...imageListContainer}>
                {(imageListItems as IImageListItem[])?.map((item: IImageListItem) => {
                    let indexKey: string;

                    if (item.image) {
                        const image = (item.image as unknown) as Msdyn365.Image;
                        indexKey = image.props.src as string;
                    } else {
                        const text = (item.text as unknown) as Msdyn365.RichTextComponent;
                        indexKey = text.props.text as string;
                    }
                    return (
                        <Node {...imageListItem} key={indexKey}>
                            {item.image && (
                                <Node
                                    {...imageListItemAnchorTag}
                                    href={item.link}
                                    altText={item.linkAltText}
                                    aria-label={item.linkAriaLabel}
                                    className={imageListItemAnchorTag.className}
                                    target={item.linkOpenInNewTab ? '_blank' : undefined}
                                >
                                    {item.image}
                                </Node>
                            )}
                            {item.text}
                        </Node>
                    );
                })}

                {(svgItems as ISvgItemsData[]).map((svg: ISvgItemsData, idx: number) => (
                    <Node
                        {...imageListItem}
                        key={`svg-${idx}`}
                        className={`${imageListItem.className} ms-image-list__item ms-image-list__item-svg`}
                    >
                        <div className='ms-image-list__svg' dangerouslySetInnerHTML={{ __html: svg.svgMarkup }} />
                        {svg.paragraph && (
                            <div
                                className='ms-image-list__text ms-image-list__item-svg-text'
                                dangerouslySetInnerHTML={{ __html: svg.paragraph?.toString() || '' }}
                            />
                        )}
                    </Node>
                ))}
            </Node>
        </Module>
    );
};

export default imageListView;
